import { Box } from '@rbilabs/universal-components';

export const Wrapper = Box.withConfig({
  justifyContent: 'center',
});
